import { Modal } from 'react-bootstrap';
import { VerticalSpacer } from './core/core';
import PrimaryButton from './components/PrimaryButton/PrimaryButton';

export const ApiCallErrorMessage = ({ isShow, onHide, apiResponseText, additionalText }) => (
  <Modal show={isShow} onHide={onHide} dialogClassName='responsiveModalWidth' centered>
    <Modal.Header closeButton>Server Error</Modal.Header>
    <Modal.Body>
      <div className='ModalDialogText apiCallErrorMessage'>
        <div className='apiResponse'>
          <div className='title'>Server Response</div>
          <div className='responseText'>{apiResponseText}</div>
        </div>
        <VerticalSpacer ems={2} />
        <p className='staticText'>There was a problem completing your request</p>
        {additionalText && <p className='staticText'>{additionalText}</p>}
      </div>
      <div style={{ textAlign: 'center', padding: '2em' }}>
        <PrimaryButton onClick={onHide}>Okay</PrimaryButton>
      </div>
    </Modal.Body>
  </Modal>
);
